import { IFinance } from '../../../types';
export type FinancialState = IFinance

export enum FinanceActionTypes {
  UPDATE_FINANCE_FIELD = '@@visa/finance/UPDATE_FINANCE_FIELD'
}
